import { useQuery } from '@tanstack/react-query';
import { useRef } from 'react';
import { useLocation } from '@provider/navigation';
import { MINUTES_TO_MS, DAYS_TO_MS } from '@utils/constants';
import { getRevisionByIdRequest } from './request.get-by-id.js';

const getRevisionByIdsQueryKey = revisionId => ["course-revisions/get-by-id", revisionId];
const getRevisionByIdQuery = revisionId => {
  return {
    queryKey: getRevisionByIdsQueryKey(revisionId),
    queryFn: () => getRevisionByIdRequest(revisionId),
    staleTime: 15 * MINUTES_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    meta: {
      persist: true
    }
  };
};
const useGetRevisionFromURLQuery = extraConfig => {
  const location = useLocation();
  const revisionIdFromURL = useRef(location.searchParams.get("revisionId")).current;
  return useQuery({
    ...getRevisionByIdQuery(revisionIdFromURL),
    ...extraConfig
  });
};

export { getRevisionByIdQuery, getRevisionByIdsQueryKey, useGetRevisionFromURLQuery };
//# sourceMappingURL=query.get-from-url.js.map
